(function ($, window) {

    // on document ready
    $(function () {

        // vars
        var $window = $(window);
        var $body = $('body');
        var tSetContentMargin;
        var scroll;
        var isScrolledDown;

        // change active class on table row clicks
        $('.table-primary.table-hover-effects').each(function() {
            var $el = $(this);
            var $tr = $el.find('tr');
            $tr.on('click',
                function() {
                    $tr.removeClass('active');
                    $(this).addClass('active');
                });
        });

        // set main-content offset due to fixed header navigation
        function setContentMargin () {
            var navHeight = $('.bes-page-header').outerHeight();
            var metaNavbarHeight = $('.meta-navbar').outerHeight();

            if (navHeight) {
                $('.main-content').css('padding-top', navHeight);

                // Add scroll margin to all sections based on current header height
                // Section will not be hidden after header on anchor scroll click
                // -40 is height of a 
                
                $('.bes-section').css('scroll-margin-top', navHeight + (isScrolledDown ? metaNavbarHeight * -1 : 0));
            }
        };
        $('.meta-navbar').on('transitionend webkitTransitionEnd oTransitionEnd', function () {
            setContentMargin();
        });
        $window.on('resize', function () {
            clearTimeout(tSetContentMargin);
            tSetContentMargin = setTimeout(setContentMargin, 200);
        });

        setContentMargin();

        // set scrolled class
        $window.on('scroll', function () {
            var newScroll = $window.scrollTop();
            if (newScroll > 0) {
                $body.addClass('is-scrolled');
                

                if (newScroll > scroll) {
                    $body.addClass('is-scrolled-down');
                    $body.removeClass('is-scrolled-up');
                    isScrolledDown = true;
                }
                else {
                    $body.removeClass('is-scrolled-down');
                    $body.addClass('is-scrolled-up');
                    isScrolledDown = false;
                }
                if (newScroll > $window.outerHeight()) {
                    $body.addClass('is-scrolled-far');
                }
                else {
                    $body.removeClass('is-scrolled-far');
                }
                scroll = newScroll;
            }
            else {
                $body.removeClass('is-scrolled');
                $body.removeClass('is-scrolled-up');
                $body.removeClass('is-scrolled-down');
                $body.removeClass('is-scrolled-far');
                isScrolledDown = false;
            }

            setContentMargin()
        });
    });
})(jQuery, window);

// toggles overview descriptions in mobile variants of product pages
function toggleOverviewDescriptionVisibility(id) {
    var elementToToggle = document.getElementById(id);
    if (!elementToToggle) return;

    // get children
    var uncut = $(elementToToggle).find(".product-teaser-overview-description__uncut");
    var cut   = $(elementToToggle).find(".product-teaser-overview-description__cut");

    // remove classes from uncut
    uncut.removeClass("d-none");

    // remove cut from dom
    cut[0].remove();
}
